import { defineComponent as _defineComponent } from 'vue'
import AppBar from '@/views/dashboard/appBar/AppBar.vue';
import StatusBar from '@/views/dashboard/appBar/StatusBar.vue';
import SecurityTab from '@/views/layouts/securityLayout/SecurityTab.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityLayout',
  emits: ["logout"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'logout'): void;
}), expose: any, slots: any, attrs: any }) {



const logout = (): void => {
  emits('logout');
};

return { __sfc: true,emits, logout, AppBar, StatusBar, SecurityTab }
}

})